import { jsx as _jsx } from "react/jsx-runtime";
import MuiWhatsApp from '@mui/icons-material/WhatsApp';
import * as React from 'react';
import { Icon } from '../base-icon';
export const IconWhatsApp = React.forwardRef((props, ref) => (_jsx(Icon, { ref: ref, iconComponent: MuiWhatsApp, outlineComponent: MuiWhatsApp, roundedComponent: MuiWhatsApp, ...props })));
